// Firebase Web config — safe to commit publicly.
// Per official Firebase docs: these keys are NOT secrets. Security is enforced
// by Firebase Rules / App Check, not by hiding these values.
// https://firebase.google.com/docs/projects/api-keys
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBc5flWs24bjBRHHwWF549dzESFDjW5a98",
  authDomain: "malat-57d0b.firebaseapp.com",
  projectId: "malat-57d0b",
  storageBucket: "malat-57d0b.firebasestorage.app",
  messagingSenderId: "825748973980",
  appId: "1:825748973980:web:ce0dbb73622421ac664059",
};

export const FIREBASE_VAPID_KEY =
  "BOBw16cyNMxagYBk8vuDZ9o0qXmDoVf7MEBlH1NORfxh2CayGfYVmkgvlL4XGYvcQq65o4hsxp4dFg-ijrjumtE";
